import { logActivity } from '@lusha/idle-management';
import { communicator, dismissAllPopups } from 'lusha-widgets';
import { reaction } from 'mobx';
import { flow, getRoot } from 'mobx-state-tree';
import { dismissNotifications } from '../../../hooks/useNotification';
import { APP_CONTEXT } from '../constants';
import { getType } from './helpers';
import { shouldPreventSearchesOnSubViews } from './utils';
const Actions = self => {
    const onUrlChange = () => {
        const root = getRoot(self);
        const { userSettings, contextContact } = root;
        const { postMessage: openFrame } = communicator.getMessenger('OPEN');
        dismissAllPopups();
        dismissNotifications();
        const haveDataOnContact = contextContact && !contextContact.isEmpty && self.isContact && userSettings.isAutoOpen;
        if (haveDataOnContact) {
            openFrame({ openType: 'autoOpen' });
        }
    };
    return {
        afterCreate: () => {
            reaction(() => self.url, onUrlChange);
        },
        setContext: context => {
            self.appContext = context ? APP_CONTEXT[context] : APP_CONTEXT.PROSPECT;
        },
        setPage: flow(function* setPage(page) {
            const root = getRoot(self);
            const { userSettings, prospecting, contextContact, user, app } = root;
            const corePluginVersion = userSettings.externalPluginVersion;
            const isNewPage = self.url !== page.url;
            if (isNewPage) {
                if (user.idleTimeout.isEnabled) {
                    logActivity();
                }
                if ((self.isContact || self.isLinkedinCompany) &&
                    userSettings.isPlatformIncludesSubViews &&
                    shouldPreventSearchesOnSubViews(page, self === null || self === void 0 ? void 0 : self.url)) {
                    return;
                }
                self.url = page.url;
                const newPageType = getType(Object.assign({ corePluginVersion }, page));
                self.type = newPageType;
                if (contextContact && (contextContact.isEmpty || self.isNewProfileUrl(page.url))) {
                    self.setLastProfileUrl(page.url);
                    contextContact.init(newPageType);
                }
                if (self.isBulk) {
                    app === null || app === void 0 ? void 0 : app.init({ firstSearch: app.firstSearch });
                }
                if (self.isCompanyPage) {
                    // prospecting is undefined sometimes. why?
                    prospecting === null || prospecting === void 0 ? void 0 : prospecting.init();
                }
            }
        }),
        setLastProfileUrl: url => {
            self.lastProfileUrl = url;
        },
        setParserResult: result => {
            self.parserResult = result;
        },
        setType: type => {
            self.type = type;
        },
        setPathname: path => {
            self.pathName = path;
        },
        onTagsChanged: contactsChanged => {
            const { app, savedTab, contact } = getRoot(self);
            if (self.isBulk && !self.isSavedTab) {
                app.selectedContacts.forEach(selectedContact => {
                    const currentContact = contactsChanged.find(contactChanged => contactChanged.contactId === selectedContact.contactId);
                    selectedContact.onTagsChanged(currentContact);
                });
            }
            else if (self.isSavedTab) {
                savedTab.selectedContact.onTagsChanged(contactsChanged[0]);
            }
            else {
                contact.onTagsChanged(contactsChanged[0]);
            }
        },
        setIsContactTagsPopupOpen: setter => {
            self.isContactTagsPopupOpen = setter;
        },
        setContactTagsPopupPosition: setter => {
            self.contactTagsPopupPosition = setter;
        },
        setSessionExpired: setter => {
            self.isSessionExpired = setter;
        },
    };
};
export default Actions;
